import { render, staticRenderFns } from "./NotificationDetailModal.vue?vue&type=template&id=57175068&scoped=true"
import script from "./NotificationDetailModal.vue?vue&type=script&lang=js"
export * from "./NotificationDetailModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetailModal.vue?vue&type=style&index=0&id=57175068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57175068",
  null
  
)

export default component.exports